import { Table } from "../../../../../components/ui/Table"
import { useSubscribers } from "../../../../../store/subscription/useSubscribers"

import { Status } from '../../Status'
import { CycleActions } from "./CycleActions"
export function SubscriptionDetailsCycles() {
  const details = useSubscribers(st => st.data.details)
  const cycles = details?.cycles

  if (!details) return null

  return (
    <Table.Root name='subscriptionDetailsCycles-table'>
      <Table.Header
        columns={[
          "Data:100px",
          "Preço:80px",
          "Pagamento:160px",
          "Status:120px",
          ":1fr"
        ]}
      />
      <Table.Content>
        {!!cycles && cycles.map((cycle) => (
          <Table.Line key={`${cycle.id}-${cycle.data.invoiceId}-${cycle.data.chargeId}`}>
            <Table.Item>{cycle.billingAt}</Table.Item>
            <Table.Item>{cycle.paidAmount}</Table.Item>
            <Table.Item>{cycle.payment}</Table.Item>
            <Table.Item><Status>{cycle.status.text}</Status></Table.Item>
            <Table.Item >
              <CycleActions cycle={cycle} />
            </Table.Item>
          </Table.Line>
        ))}
      </Table.Content>
    </Table.Root>
  )
}
